<template>
<div v-if="isLoading" class="overlay">
    <div class="spinner">
        <div class="bounce1" :style="loadStyles"></div>
        <div class="bounce2" :style="loadStyles"></div>
        <div class="bounce3" :style="loadStyles"></div>
    </div>
</div>
</template>

<script>
export default {
  name: "t-loading",
  props: {
    isLoading: { type: Boolean, default: false },
    color: { type: String, default: "#aaaaaa" }
  },
  methods: {},
  computed: {
    // バインドするスタイルを生成
    loadStyles() {
      return {
        "background-color": this.color
      };
    }
  },

  data() {
    return {
      // loadStyles: {
      //   backgroundColor: this.color
      // }
    };
  },

  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.overlay {
}
.spinner {
  margin: 0;

  text-align: center;

  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.spinner > div {
  width: 1em;
  height: 1em;
  background-color: silver;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TLoading.vue